import { render } from "./AppSubMenu.vue?vue&type=template&id=0c262e1a&scoped=true"
import script from "./AppSubMenu.vue?vue&type=script&lang=js"
export * from "./AppSubMenu.vue?vue&type=script&lang=js"

import "./AppSubMenu.vue?vue&type=style&index=0&id=0c262e1a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c262e1a"]])

export default __exports__